import React from 'react';
import { Icon } from './icon';
import { Text } from './text';
import './header.css';

/**
 * Header
 */
export const Header = (props) => {

    const caption = props.caption ? 'caption' : ''
    const prominent = props.prominent ? 'prominent' : ''
    const dense = props.dense ? 'dense' : ''
    let theme = props.primary ? 'primary' : ''
    theme = props.secondary ? 'secondary' : theme
    let icon = props.icon ? <Icon icon={props.icon} clickable={props.clickable} action={props.action}/> : ''
    icon = props.iconSrc ? <img className="header-icon" src={props.iconSrc} /> : icon;

    const style = props.img ? { backgroundImage: `url(${props.img })` } : {}

    const title=<Text>{props.title}</Text>
    return (
        <header className={`header ${caption} ${prominent} ${dense} ${theme} ${props.className}`} style={style}>
            {icon}
            {props.title ? <label>{title}</label> : null }
            <span className="actions">{props.children}</span>
        </header>
    )
}

